import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "ion-text-center ion-margin-top ion-padding"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"100px","margin":"0 auto"},
    src: _imports_0
  })
], -1)
const _hoisted_4 = { class: "ion-margin-vertical" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { style: {"margin":"5px auto"} }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { id: "picker" }, null, -1)
const _hoisted_8 = { style: {"padding-top":"8px"} }
const _hoisted_9 = { class: "grey-bg color-buttons" }
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { style: {"font-size":"36px"} }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_popover = _resolveComponent("ion-popover")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_v_image = _resolveComponent("v-image")!
  const _component_v_layer = _resolveComponent("v-layer")!
  const _component_v_stage = _resolveComponent("v-stage")!
  const _component_v_rect = _resolveComponent("v-rect")!
  const _component_v_text = _resolveComponent("v-text")!
  const _component_v_group = _resolveComponent("v-group")!
  const _component_v_transformer = _resolveComponent("v-transformer")!
  const _component_v_line = _resolveComponent("v-line")!
  const _component_v_circle = _resolveComponent("v-circle")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_range = _resolveComponent("ion-range")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, {
            fixed: "",
            style: {"padding":"0"}
          }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.leaveFilterMode()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: $setup.close
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_buttons, { slot: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.setPopoverOpen('menu', true, $event)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            ios: $setup.ellipsisHorizontal,
                            md: $setup.ellipsisVertical
                          }, null, 8, ["ios", "md"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512), [
                [_vShow, $setup.canvas.isFiltering]
              ]),
              _withDirectives(_createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.resetEraseImage()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: $setup.close
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_buttons, { slot: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        color: "primary",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.undo($setup.eraserHistory))),
                        disabled: $setup.eraserHistory.step == -1
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: $setup.arrowUndoOutline
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_component_ion_button, {
                        color: "primary",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.redo($setup.eraserHistory))),
                        disabled: $setup.eraserHistory.states.length == 0 || $setup.eraserHistory.step >= $setup.eraserHistory.states.length-1
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: $setup.arrowRedoOutline
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_buttons, { slot: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        color: "success",
                        fill: "solid",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.completeEraseImage($setup.canvas.erasingShape)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.t('done')) + " ", 1),
                          _createVNode(_component_ion_icon, {
                            slot: "end",
                            icon: $setup.checkmark
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512), [
                [_vShow, $setup.canvas.isErasing]
              ]),
              _withDirectives(_createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_ion_button, {
                        color: "primary",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.leavePage()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: $setup.arrowBack
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, !$setup.canvas.selectedShape.id]
                      ]),
                      _withDirectives(_createVNode(_component_ion_button, {
                        color: "primary",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.setCanvasSelectedShape({ id: '' })))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: $setup.close
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, $setup.canvas.selectedShape.id]
                      ])
                    ]),
                    _: 1
                  }),
                  _withDirectives(_createVNode(_component_ion_title, {
                    style: {"padding-inline":"unset","padding-left":"8px"},
                    onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.openUpdateStickerNamePrompt()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createElementVNode("p", null, _toDisplayString($setup.sticker.name), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, !$setup.canvas.selectedShape.id]
                  ]),
                  _withDirectives(_createVNode(_component_ion_title, { style: {"padding-inline":"unset"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createElementVNode("p", null, _toDisplayString($setup.canvas.selectedShape.text || $setup.canvas.selectedShape.name || ''), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, $setup.canvas.selectedShape.id]
                  ]),
                  _createVNode(_component_ion_buttons, { slot: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        color: "primary",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.undo($setup.appHistory))),
                        disabled: $setup.appHistory.step == -1
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: $setup.arrowUndoOutline
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_component_ion_button, {
                        color: "primary",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.redo($setup.appHistory))),
                        disabled: $setup.appHistory.states.length == 0 || $setup.appHistory.step >= $setup.appHistory.states.length-1
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: $setup.arrowRedoOutline
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _withDirectives(_createVNode(_component_ion_button, {
                        color: "dark",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.removeShape($setup.canvas.selectedShape.id, true)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: $setup.trashOutline
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, $setup.canvas.selectedShape.id]
                      ]),
                      _withDirectives(_createVNode(_component_ion_button, {
                        color: "dark",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.downloadSelectedImage()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: $setup.downloadOutline
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, $setup.isSelectingCustomImage()]
                      ]),
                      _createVNode(_component_ion_button, {
                        onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.setPopoverOpen('menu', true, $event)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            ios: $setup.ellipsisHorizontal,
                            md: $setup.ellipsisVertical
                          }, null, 8, ["ios", "md"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_popover, {
                    "is-open": $setup.popoverState.menu,
                    event: $setup.popoverEvent,
                    onDidDismiss: _cache[21] || (_cache[21] = ($event: any) => ($setup.setPopoverOpen('menu', false))),
                    "dismiss-on-select": true
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_content, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_list, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_item, {
                                onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.previewSticker())),
                                button: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    icon: $setup.eyeOutline
                                  }, null, 8, ["icon"]),
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($setup.t('stickerPreview')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_item, {
                                onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.shareCanvasImg())),
                                button: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    icon: $setup.shareSocialOutline
                                  }, null, 8, ["icon"]),
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($setup.t('shareSticker')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_item, {
                                onClick: _cache[16] || (_cache[16] = ($event: any) => ($setup.saveCanvasImg())),
                                button: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    icon: $setup.downloadOutline
                                  }, null, 8, ["icon"]),
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($setup.t('downloadSticker')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_item, {
                                onClick: _cache[17] || (_cache[17] = ($event: any) => ($setup.openStickerListModal())),
                                button: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    icon: $setup.folderOutline
                                  }, null, 8, ["icon"]),
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($setup.t('mySavedStickers')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              ($setup.sticker.id)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                    _createVNode(_component_ion_item, {
                                      onClick: _cache[18] || (_cache[18] = ($event: any) => ($setup.openUpdateStickerNamePrompt())),
                                      button: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, {
                                          slot: "start",
                                          icon: $setup.createOutline
                                        }, null, 8, ["icon"]),
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString($setup.t('updateStickerName')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    (!$setup.reachedStickerLimit())
                                      ? (_openBlock(), _createBlock(_component_ion_item, {
                                          key: 0,
                                          onClick: _cache[19] || (_cache[19] = ($event: any) => ($setup.cloneSticker($setup.sticker))),
                                          button: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_icon, {
                                              slot: "start",
                                              icon: $setup.copyOutline
                                            }, null, 8, ["icon"]),
                                            _createVNode(_component_ion_label, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString($setup.t('makeACopy')), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_ion_item, {
                                      onClick: _cache[20] || (_cache[20] = ($event: any) => ($setup.deleteSticker($setup.sticker.id))),
                                      lines: "none",
                                      button: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, {
                                          color: "danger",
                                          slot: "start",
                                          icon: $setup.trashOutline
                                        }, null, 8, ["icon"]),
                                        _createVNode(_component_ion_label, { color: "danger" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString($setup.t('deleteSticker')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["is-open", "event"])
                ]),
                _: 1
              }, 512), [
                [_vShow, !$setup.canvas.isErasing && !$setup.canvas.isFiltering]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, {
            class: "ion-no-padding",
            fixed: ""
          }, {
            default: _withCtx(() => [
              ($setup.canvas.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("h3", _hoisted_4, _toDisplayString($setup.t('loadingAssets')), 1),
                    _createVNode(_component_ion_spinner)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_ion_row, { class: "ion-justify-content-center ion-text-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "12" }, {
                    default: _withCtx(() => [
                      (!$setup.canvas.loading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createVNode(_component_ion_toolbar, null, {
                              default: _withCtx(() => [
                                _withDirectives(_createVNode(_component_ion_segment, {
                                  mode: "ios",
                                  style: {"min-height":"40px","height":"40px"},
                                  modelValue: $setup.dummy,
                                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($setup.dummy) = $event)),
                                  onIonChange: _cache[25] || (_cache[25] = ($event: any) => ($setup.dummy = 'dummy')),
                                  scrollable: "",
                                  disabled: $setup.canvas.isFiltering
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_segment_button, {
                                      onClick: _cache[22] || (_cache[22] = ($event: any) => ($setup.openTextPrompt())),
                                      layout: "icon-start"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, { icon: $setup.add }, null, 8, ["icon"]),
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString($setup.t('addText')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_segment_button, {
                                      onClick: _cache[23] || (_cache[23] = ($event: any) => ($setup.openNewCustomImagePrompt())),
                                      layout: "icon-start"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, { icon: $setup.cameraOutline }, null, 8, ["icon"]),
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString($setup.t('addImage')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "disabled"]), [
                                  [_vShow, !$setup.canvas.isErasing && !$setup.canvas.selectedShape.id]
                                ]),
                                _withDirectives(_createVNode(_component_ion_segment, {
                                  mode: "ios",
                                  style: {"height":"48px"},
                                  modelValue: $setup.dummy,
                                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (($setup.dummy) = $event)),
                                  onIonChange: _cache[34] || (_cache[34] = ($event: any) => ($setup.dummy = 'dummy')),
                                  scrollable: "",
                                  disabled: $setup.canvas.isErasing
                                }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createVNode(_component_ion_segment_button, {
                                      onClick: _cache[26] || (_cache[26] = ($event: any) => ($setup.openStickerPreQuestionModal($setup.sticker.id, $setup.canvas.selectedShape.id)))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, { icon: $setup.createOutline }, null, 8, ["icon"]),
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString($setup.t('editPetPhoto')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 512), [
                                      [_vShow, $setup.canvas.isErasing || $setup.isSelectingCustomImage()]
                                    ]),
                                    _withDirectives(_createVNode(_component_ion_segment_button, {
                                      onClick: _cache[27] || (_cache[27] = ($event: any) => ($setup.startErasingImage())),
                                      class: _normalizeClass({ 'segment-button-checked' :$setup.canvas.isErasing })
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, { icon: $setup.removeCircleOutline }, null, 8, ["icon"]),
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString($setup.t('eraseImage')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["class"]), [
                                      [_vShow, $setup.canvas.isErasing || $setup.isSelectingCustomImage()]
                                    ]),
                                    _withDirectives(_createVNode(_component_ion_segment_button, {
                                      onClick: _cache[28] || (_cache[28] = ($event: any) => ($setup.openTextPrompt($setup.canvas.selectedShape)))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, { icon: $setup.createOutline }, null, 8, ["icon"]),
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString($setup.t('editText')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 512), [
                                      [_vShow, $setup.isSelectingCustomText()]
                                    ]),
                                    _createVNode(_component_ion_segment_button, {
                                      onClick: _cache[29] || (_cache[29] = ($event: any) => ($setup.flipSelectedShape())),
                                      disabled: $setup.canvas.isFlipping
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, { icon: $setup.swapHorizontal }, null, 8, ["icon"]),
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString($setup.t('flip')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"]),
                                    _createVNode(_component_ion_segment_button, {
                                      onClick: _cache[30] || (_cache[30] = ($event: any) => ($setup.moveSelectedShape('up')))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, { icon: $setup.chevronUp }, null, 8, ["icon"]),
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString($setup.t('moveUp')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_segment_button, {
                                      onClick: _cache[31] || (_cache[31] = ($event: any) => ($setup.moveSelectedShape('down')))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, { icon: $setup.chevronDown }, null, 8, ["icon"]),
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString($setup.t('moveDown')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_segment_button, {
                                      onClick: _cache[32] || (_cache[32] = ($event: any) => ($setup.duplicateSelectedShape()))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, { icon: $setup.duplicateOutline }, null, 8, ["icon"]),
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString($setup.t('duplicate')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "disabled"]), [
                                  [_vShow, $setup.canvas.isErasing || $setup.canvas.selectedShape.id]
                                ])
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", {
                              class: "ion-margin-top",
                              style: _normalizeStyle([{"border":"1px solid grey","border-radius":"8px","margin":"0 auto"}, { width: `${$setup.canvas.sceneWidth}px` }])
                            }, [
                              _withDirectives(_createVNode(_component_v_stage, {
                                ref: "filterStageRef",
                                config: { width: $setup.canvas.sceneWidth, height: $setup.canvas.sceneHeight }
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_layer, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_image, {
                                        config: {
                      id: 'filteringImg',
                      x: 0,
                      y: 0,
                      scaleX: $setup.canvas.filteringImg.scale,
                      scaleY: $setup.canvas.filteringImg.scale,
                      image: $setup.canvas.filteringImg.image,
                      pixelSize: $setup.canvas.filteringImg.pixelSize,
                      levels: Math.abs($setup.canvas.filteringImg.levels),
                    }
                                      }, null, 8, ["config"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["config"]), [
                                [_vShow, $setup.canvas.isFiltering]
                              ]),
                              _withDirectives(_createVNode(_component_v_stage, {
                                ref: "stageRef",
                                config: { width: $setup.canvas.sceneWidth, height: $setup.canvas.sceneHeight },
                                onMousedown: $setup.handleStageMouseDown,
                                onTouchstart: $setup.handleStageMouseDown,
                                onMousemove: $setup.handleStageMouseMove,
                                onTouchmove: $setup.handleStageMouseMove,
                                onMouseup: $setup.handleStageTouchEnd,
                                onTouchend: $setup.handleStageTouchEnd
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_layer, null, {
                                    default: _withCtx(() => [
                                      ($setup.canvas.backgroundImage)
                                        ? (_openBlock(), _createBlock(_component_v_rect, {
                                            key: 0,
                                            config: {
                        width: $setup.canvas.sceneWidth,
                        height: $setup.canvas.sceneHeight,
                        fillPatternImage: $setup.canvas.backgroundImage,
                        fillPatternScaleX: $setup.canvas.backgroundImageScale,
                        fillPatternScaleY: $setup.canvas.backgroundImageScale,
                        fillPatternX: $setup.canvas.backgroundImageX,
                        fillPatternY: $setup.canvas.backgroundImageY,
                      }
                                          }, null, 8, ["config"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_layer, {
                                    config: {
                      name: 'designLayer',
                      listening: !$setup.canvas.isErasing && !$setup.canvas.isSelectingBackground,
                      scaleX: $setup.canvas.designLayerScale,
                      scaleY: $setup.canvas.designLayerScale,
                      x: $setup.canvas.designLayerX,
                      y: $setup.canvas.designLayerY,
                    }
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.canvas.shapes.filter(s => !!s.id), (s) => {
                                        return (_openBlock(), _createBlock(_component_v_group, {
                                          key: s.id
                                        }, {
                                          default: _withCtx(() => [
                                            (s.type == 'text')
                                              ? (_openBlock(), _createBlock(_component_v_text, {
                                                  key: 0,
                                                  onTransform: $setup.handleTransform,
                                                  onTransformend: $setup.handleTransformEnd,
                                                  config: {
                          lineHeight: s.lineHeight || 1,
                          type: s.type,
                          category: s.category || '',
                          id: s.id,
                          x: s.x,
                          y: s.y,
                          fill: s.color || 'rgb(0,0,0)',
                          text: s.text,
                          fontSize: 36,
                          scaleX: s.scaleX || 1,
                          scaleY: s.scaleY || 1,
                          align: 'center',
                          verticalAlign: 'middle',
                          fontFamily: s.fontFamily || $setup.canvas.defaultFontFamily,
                          rotation: s.rotation,
                          visible: s.visible != false && $setup.canvas.layerVisibility[s.materialId ? 'accessories' : s.type],
                          listening: ($setup.canvas.lockMoveSelectedShape && s.id != $setup.canvas.selectedShape.id) ? false : true,
                          draggable: $setup.canvas.isPinching ? false : true,
                          stroke: s.strokeColor || $setup.canvas.defaultStrokeColor,
                          strokeWidth: $setup.isNumber(s.strokeWidth) ? s.strokeWidth : $setup.canvas.defaultStrokeWidth,
                          fontStyle: s.fontStyle || '',
                          fillAfterStrokeEnabled: true,
                          name: 'object',
                        }
                                                }, null, 8, ["onTransform", "onTransformend", "config"]))
                                              : (_openBlock(), _createBlock(_component_v_image, {
                                                  key: 1,
                                                  onTransform: $setup.handleTransform,
                                                  onTransformend: $setup.handleTransformEnd,
                                                  config: {
                          type: s.type,
                          category: s.category || '',
                          id: s.id,
                          width: s.width ? s.width : undefined,
                          height: s.height ? s.height : undefined,
                          x: s.x,
                          y: s.y,
                          rotation: s.rotation,
                          scaleX: s.scaleX || 1,
                          scaleY: s.scaleY || 1,
                          image: s.loadedImg,
                          name: s.name,
                          visible: $setup.canvas.isErasing ? !!s.materialId : (s.visible != false && $setup.canvas.layerVisibility[s.materialId ? 'accessories' : s.type]),
                          //visible: s.visible != false && canvas.layerVisibility[s.materialId ? 'accessories' : s.type],
                          listening: ($setup.canvas.lockMoveSelectedShape && s.id != $setup.canvas.selectedShape.id) ? false : true,
                          draggable: $setup.canvas.isPinching ? false : true,
                          brightness: s.brightness || 0,
                          blurRadius: s.blurRadius || 0,
                        }
                                                }, null, 8, ["onTransform", "onTransformend", "config"]))
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128)),
                                      _createVNode(_component_v_transformer, {
                                        ref: "transformer",
                                        onDragmove: $setup.handleTrDragMove,
                                        onDragend: $setup.handleTrDragEnd,
                                        config: {
                      keepRatio: true,
                      resizeEnabled: true,
                      rotationSnaps: [0, 90, 180, 270],
                      centeredScaling: false,
                      enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right'],
                      anchorStrokeWidth: 3,
                      anchorCornerRadius: 20,
                      anchorSize: 20,
                      rotateAnchorOffset: 20,
                      useSingleNodeRotation: false,
                      flipEnabled: false,
                    }
                                      }, null, 8, ["onDragmove", "onDragend"])
                                    ]),
                                    _: 1
                                  }, 8, ["config"]),
                                  _createVNode(_component_v_layer, {
                                    config: {
                    name: 'eraserLayer',
                    visible: $setup.canvas.isErasing,
                    scaleX: $setup.canvas.designLayerScale,
                    scaleY: $setup.canvas.designLayerScale,
                    x: $setup.canvas.designLayerX,
                    y: $setup.canvas.designLayerY,
                  }
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_group, { config: {
                        name: 'erasedImgGroup',
                      } }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_image, {
                                            config: {
                          id: 'erasedImg',
                          width: $setup.canvas.erasingShape.width,
                          height: $setup.canvas.erasingShape.height,
                          x: $setup.canvas.erasingShape.x,
                          y: $setup.canvas.erasingShape.y,
                          rotation: $setup.canvas.erasingShape.rotation,
                          scaleX: $setup.canvas.erasingShape.scaleX,
                          scaleY: $setup.canvas.erasingShape.scaleY,
                          image: $setup.canvas.erasingShape.loadedImg,
                        }
                                          }, null, 8, ["config"]),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.canvas.erasingLines, (line) => {
                                            return (_openBlock(), _createBlock(_component_v_line, {
                                              key: line.id,
                                              config: {
                        points: line.points,
                        stroke: 'red',
                        strokeWidth: line.strokeWidth,
                        lineCap: 'round',
                        lineJoin: 'round',
                        perfectDrawEnabled: false,
                        hitStrokeWidth: 0,
                        shadowForStrokeEnabled: false,
                        globalCompositeOperation: 'destination-out',
                      }
                                            }, null, 8, ["config"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_group, {
                                        config: {
                        id: 'eraserGroup',
                        x: (30-$setup.canvas.designLayerX)/$setup.canvas.designLayerScale,
                        y: (30-$setup.canvas.designLayerY)/$setup.canvas.designLayerScale,
                        draggable: true,
                      },
                                        onDragmove: $setup.handleEraserDragMove,
                                        onDragend: $setup.handleEraserDragEnd
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_circle, {
                                            config: {
                        x: 30,
                        y: 30,
                        radius: 5 / $setup.canvas.designLayerScale,
                        stroke: 'white',
                        fill: 'red',
                        opacity: 0.8,
                        strokeWidth: 1 / $setup.canvas.designLayerScale,
                      }
                                          }, null, 8, ["config"]),
                                          _createVNode(_component_v_circle, {
                                            config: {
                        x: 0,
                        y: 0,
                        radius: Math.max($setup.canvas.minEraserHelperRadius, $setup.canvas.eraserRadius * 5),
                        fill: 'transparent',
                        perfectDrawEnabled: false,
                        shadowForStrokeEnabled: false,
                      }
                                          }, null, 8, ["config"]),
                                          _createVNode(_component_v_circle, {
                                            config: {
                        id: 'eraser',
                        x: 0,
                        y: 0,
                        radius: $setup.canvas.eraserRadius,
                        stroke: 'black',
                        strokeWidth: 2 / $setup.canvas.designLayerScale,
                      }
                                          }, null, 8, ["config"])
                                        ]),
                                        _: 1
                                      }, 8, ["config", "onDragmove", "onDragend"])
                                    ]),
                                    _: 1
                                  }, 8, ["config"]),
                                  _createVNode(_component_v_layer, { config: {
                    name: 'lineGuideLayer'
                  } }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.canvas.lineGuides, (line, i) => {
                                        return (_openBlock(), _createBlock(_component_v_line, {
                                          key: i,
                                          config: {
                      points: line.points,
                      stroke: 'rgb(0, 161, 255)',
                      strokeWidth: 1,
                      name: 'guide-line',
                      dash: [4, 6],
                      x: line.x,
                      y: line.y
                    }
                                        }, null, 8, ["config"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["config", "onMousedown", "onTouchstart", "onMousemove", "onTouchmove", "onMouseup", "onTouchend"]), [
                                [_vShow, !$setup.canvas.isFiltering]
                              ])
                            ], 4)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_modal, {
            id: "panel-modal",
            "is-open": true,
            "initial-breakpoint": 0.4,
            breakpoints: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6],
            "backdrop-dismiss": false,
            "backdrop-breakpoint": 1,
            "show-backdrop": false,
            "keep-contents-mounted": true,
            onDidPresent: _cache[65] || (_cache[65] = ($event: any) => ($setup.onModalPresent()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_content, { class: "ion-no-padding grey-bg" }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_ion_card, {
                    style: {"padding-bottom":"5px"},
                    class: "ion-no-padding ion-text-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, { lines: "none" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createElementVNode("h3", null, _toDisplayString($setup.t('eraserSize')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_range, {
                            min: "2",
                            max: "30",
                            step: "1",
                            modelValue: $setup.canvas.eraserRadius,
                            "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (($setup.canvas.eraserRadius) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, { slot: "start" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString($setup.t('small')), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_label, { slot: "end" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString($setup.t('big')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, $setup.canvas.isErasing]
                  ]),
                  _withDirectives(_createVNode(_component_ion_card, {
                    style: {"padding":"8px 0"},
                    class: "ion-text-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_toolbar, { style: {"height":"36px","--min-height":"36px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_buttons, {
                            slot: "start",
                            style: {"height":"36px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                slot: "icon-only",
                                onClick: _cache[36] || (_cache[36] = ($event: any) => ($setup.setCanvasSelectedShape({ id: '' })))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, { icon: $setup.arrowBack }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_segment, {
                            mode: "ios",
                            modelValue: $setup.canvas.targetImgAttr,
                            "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (($setup.canvas.targetImgAttr) = $event)),
                            scrollable: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_segment_button, {
                                value: "brightness",
                                layout: "icon-start"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($setup.t('brightness')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_segment_button, {
                                value: "softEdges",
                                layout: "icon-start"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($setup.t('softEdges')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _withDirectives(_createVNode(_component_ion_range, {
                        mode: "ios",
                        pin: true,
                        "pin-formatter": (val) => `${parseFloat(val.toFixed(1))}`,
                        ticks: true,
                        snaps: true,
                        min: "-0.7",
                        max: "0.7",
                        step: "0.1",
                        modelValue: $setup.canvas.selectedShape.brightness,
                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (($setup.canvas.selectedShape.brightness) = $event)),
                        onIonChange: _cache[39] || (_cache[39] = ($event: any) => ($setup.addFiltersToSelectedShape()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { slot: "start" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.t('dimmer')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_label, { slot: "end" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.t('brighter')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["pin-formatter", "modelValue"]), [
                        [_vShow, $setup.canvas.targetImgAttr == 'brightness']
                      ]),
                      _withDirectives(_createVNode(_component_ion_range, {
                        style: {"padding-bottom":"0"},
                        mode: "ios",
                        min: "0",
                        max: "50",
                        step: "1",
                        modelValue: $setup.canvas.selectedShape.blurRadius,
                        "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (($setup.canvas.selectedShape.blurRadius) = $event)),
                        onIonChange: _cache[41] || (_cache[41] = ($event: any) => ($setup.addFiltersToSelectedShape()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { slot: "start" }, {
                            default: _withCtx(() => [
                              _createTextVNode("0")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_label, { slot: "end" }, {
                            default: _withCtx(() => [
                              _createTextVNode("50")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]), [
                        [_vShow, $setup.canvas.targetImgAttr == 'softEdges']
                      ])
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, $setup.isSelectingCustomImage()]
                  ]),
                  _withDirectives(_createVNode(_component_ion_card, {
                    style: {"padding-bottom":"5px"},
                    class: "ion-no-padding ion-text-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_range, {
                        style: {"padding-bottom":"0"},
                        mode: "ios",
                        min: "0.1",
                        max: "2",
                        step: "0.1",
                        modelValue: $setup.canvas.backgroundImageScale,
                        "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (($setup.canvas.backgroundImageScale) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { slot: "start" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.t('small')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_label, { slot: "end" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.t('big')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, $setup.canvas.isSelectingBackground]
                  ]),
                  _withDirectives(_createVNode(_component_ion_card, {
                    style: {"padding-bottom":"5px"},
                    class: "ion-no-padding ion-text-center"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_ion_range, {
                        style: {"padding-bottom":"0"},
                        mode: "ios",
                        min: "-0.03",
                        max: "0",
                        step: "0.005",
                        modelValue: $setup.canvas.filteringImg.levels,
                        "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (($setup.canvas.filteringImg.levels) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { slot: "start" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.t('less')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_label, { slot: "end" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.t('more')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]), [
                        [_vShow, $setup.canvas.selectedFilter == $setup.photoFilters.posterize]
                      ]),
                      _withDirectives(_createVNode(_component_ion_range, {
                        style: {"padding-bottom":"0"},
                        min: "3",
                        max: "10",
                        step: "0.5",
                        modelValue: $setup.canvas.filteringImg.pixelSize,
                        "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => (($setup.canvas.filteringImg.pixelSize) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { slot: "start" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.t('less')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_label, { slot: "end" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.t('more')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]), [
                        [_vShow, $setup.canvas.selectedFilter == $setup.photoFilters.pixelate]
                      ])
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, $setup.canvas.isFiltering]
                  ]),
                  _withDirectives(_createVNode(_component_ion_card, { class: "ion-no-padding" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_toolbar, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_buttons, { slot: "start" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                slot: "icon-only",
                                onClick: _cache[45] || (_cache[45] = ($event: any) => ($setup.setCanvasSelectedShape({ id: '' })))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, { icon: $setup.arrowBack }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_buttons, { slot: "start" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                fill: "solid",
                                style: _normalizeStyle(`border: 1px solid lightgrey; --background: ${$setup.canvas.selectedShape[$setup.canvas.colorChangeTarget]}`)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("    ")
                                ]),
                                _: 1
                              }, 8, ["style"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_select, {
                            placeholder: $setup.t('changeFontFamily'),
                            style: {"padding-right":"14px"},
                            modelValue: $setup.canvas.selectedShape.fontFamily,
                            "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => (($setup.canvas.selectedShape.fontFamily) = $event)),
                            interface: "popover"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_select_option, {
                                value: "",
                                disabled: ""
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString($setup.t('changeFontFamily')), 1)
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.canvas.fontFamilyOptions, (fontFamily) => {
                                return (_openBlock(), _createBlock(_component_ion_select_option, {
                                  key: fontFamily,
                                  value: fontFamily
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(fontFamily), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["placeholder", "modelValue"]),
                          _createVNode(_component_ion_chip, {
                            slot: "end",
                            outline: !(($setup.canvas.selectedShape.fontStyle || '').includes('bold')),
                            onClick: _cache[47] || (_cache[47] = ($event: any) => ($setup.toggleFontStyle('bold')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("b", null, _toDisplayString($setup.t('bold')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["outline"]),
                          _createVNode(_component_ion_chip, {
                            slot: "end",
                            outline: !(($setup.canvas.selectedShape.fontStyle || '').includes('italic')),
                            onClick: _cache[48] || (_cache[48] = ($event: any) => ($setup.toggleFontStyle('italic')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("i", null, _toDisplayString($setup.t('italic')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["outline"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_ion_segment, {
                          mode: "ios",
                          modelValue: $setup.canvas.colorChangeTarget,
                          "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => (($setup.canvas.colorChangeTarget) = $event)),
                          scrollable: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_segment_button, {
                              value: "color",
                              layout: "icon-start"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString($setup.t('textColor')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_segment_button, {
                              value: "strokeColor",
                              layout: "icon-start"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString($setup.t('strokeColor')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ion_toolbar, {
                          class: "ion-text-center grey-bg",
                          style: {"--min-height":"24px"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.settings.defaultTextColorCodes, (color, i) => {
                              return (_openBlock(), _createBlock(_component_ion_button, {
                                key: i,
                                onClick: ($event: any) => ($setup.changeTextColor(color)),
                                style: _normalizeStyle(`--background: ${color}; padding-right: 3px`),
                                size: "small",
                                shape: "round"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("   ")
                                ]),
                                _: 2
                              }, 1032, ["onClick", "style"]))
                            }), 128)),
                            _createVNode(_component_ion_button, {
                              class: "more-color-btn",
                              onClick: _cache[50] || (_cache[50] = ($event: any) => ($setup.setPopoverOpen('textColor', true, $event))),
                              shape: "round",
                              fill: "clear",
                              size: "small",
                              style: {"--background":"transparent"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  slot: "icon-only",
                                  icon: $setup.add
                                }, null, 8, ["icon"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_popover, {
                          mode: "md",
                          isOpen: $setup.popoverState.textColor,
                          event: $setup.popoverEvent,
                          onDidDismiss: _cache[51] || (_cache[51] = ($event: any) => ($setup.setPopoverOpen('textColor', false))),
                          dismissOnSelect: true,
                          showBackdrop: false,
                          keepContentsMounted: true
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_content, { class: "ion-padding" }, {
                              default: _withCtx(() => [
                                _hoisted_7
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["isOpen", "event"]),
                        _createVNode(_component_ion_item, { lines: "none" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createElementVNode("h3", null, _toDisplayString($setup.t('textStroke')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_range, {
                              min: "0",
                              max: "5",
                              step: "0.1",
                              modelValue: $setup.canvas.selectedShape.strokeWidth,
                              "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => (($setup.canvas.selectedShape.strokeWidth) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { slot: "start" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString($setup.t('thin')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_label, { slot: "end" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString($setup.t('thick')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, $setup.isSelectingCustomText()]
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives(_createElementVNode("div", null, [
                      ($setup.isForDIYProduct())
                        ? (_openBlock(), _createBlock(_component_ion_toolbar, {
                            key: 0,
                            class: "grey-bg",
                            style: {"--min-height":"48px"}
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createVNode(_component_ion_title, {
                                class: "ion-text-center",
                                style: {"padding-inline":"0"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_button, {
                                    style: {"text-transform":"none","vertical-align":"top","font-size":"16px"},
                                    expand: "block",
                                    color: "secondary",
                                    onClick: _cache[53] || (_cache[53] = ($event: any) => ($setup.openDIYProductModal($setup.sticker)))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($setup.t('createDIYProducts')) + " ", 1),
                                      _createVNode(_component_ion_icon, {
                                        slot: "end",
                                        icon: $setup.arrowForward
                                      }, null, 8, ["icon"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 512), [
                                [_vShow, !$setup.canvas.isFiltering]
                              ])
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_ion_toolbar, {
                            key: 1,
                            class: "grey-bg",
                            style: {"--min-height":"48px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_title, {
                                class: "ion-text-center",
                                style: {"padding-inline":"0"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_button, {
                                    style: {"text-transform":"none","vertical-align":"top","font-size":"16px"},
                                    expand: "block",
                                    color: "success",
                                    onClick: _cache[54] || (_cache[54] = ($event: any) => ($setup.saveStickerToWhatsApp()))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: $setup.logoWhatsapp
                                      }, null, 8, ["icon"]),
                                      _createTextVNode(" " + _toDisplayString($setup.t('saveStickerToWhatsApp')) + " ", 1),
                                      _createVNode(_component_ion_icon, {
                                        slot: "end",
                                        icon: $setup.arrowForward
                                      }, null, 8, ["icon"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                    ], 512), [
                      [_vShow, $setup.canvas.shapes.length > 0]
                    ]),
                    _withDirectives(_createVNode(_component_ion_toolbar, { class: "grey-bg" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_buttons, { slot: "start" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_button, {
                              fill: "solid",
                              shape: "round",
                              class: "nav-category-btn",
                              onClick: _cache[55] || (_cache[55] = ($event: any) => ($setup.navigateMaterialCategories('prev'))),
                              color: "primary"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  slot: "icon-only",
                                  icon: $setup.chevronBack
                                }, null, 8, ["icon"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_segment, {
                          style: {"height":"48px"},
                          onIonChange: _cache[56] || (_cache[56] = ($event: any) => ($setup.onMaterialCategoryChanged())),
                          class: "sections",
                          modelValue: $setup.canvas.selectedSectionTab,
                          "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => (($setup.canvas.selectedSectionTab) = $event)),
                          scrollable: ""
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_ion_segment_button, { value: "已選" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString($setup.t('selected')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 512), [
                              [_vShow, $setup.canvas.shapes.length > 0]
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.materialCategories, (category) => {
                              return (_openBlock(), _createBlock(_component_ion_segment_button, {
                                key: category.id,
                                value: category.id
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($setup.getLocalizedStr(category, 'name', 'nameEn')), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ion_buttons, { slot: "end" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_button, {
                              fill: "solid",
                              shape: "round",
                              class: "nav-category-btn",
                              onClick: _cache[58] || (_cache[58] = ($event: any) => ($setup.navigateMaterialCategories('next'))),
                              color: "primary"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  slot: "icon-only",
                                  icon: $setup.chevronForward
                                }, null, 8, ["icon"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, !$setup.canvas.isFiltering]
                    ]),
                    _createVNode(_component_ion_popover, {
                      class: "color-popover",
                      "is-open": $setup.isColorPopoverOpenRef,
                      event: $setup.colorPopoverEvent,
                      showBackdrop: true,
                      side: "top",
                      onDidDismiss: _cache[59] || (_cache[59] = ($event: any) => ($setup.isColorPopoverOpenRef = false)),
                      "dismiss-on-select": true
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.canvas.selectedPanelShape.colors, (color, i) => {
                            return (_openBlock(), _createBlock(_component_ion_button, {
                              key: i,
                              onClick: ($event: any) => ($setup.addMaterialToCanvas($setup.canvas.selectedPanelShape, color)),
                              style: _normalizeStyle(`--background: ${color.colorHex}`),
                              size: "small",
                              shape: "round"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("   ")
                              ]),
                              _: 2
                            }, 1032, ["onClick", "style"]))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    }, 8, ["is-open", "event"]),
                    _withDirectives(_createElementVNode("div", {
                      class: "material-div grey-bg",
                      onTouchmove: _cache[63] || (_cache[63] = (e) => e.stopPropagation())
                    }, [
                      _withDirectives(_createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          ($setup.canvas.backgroundImage)
                            ? (_openBlock(), _createBlock(_component_ion_col, {
                                key: 0,
                                "size-xs": "3",
                                "size-lg": "2",
                                class: "ion-no-padding ion-text-center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_card, {
                                    class: _normalizeClass(["material-card", { 'highlight-card': $setup.canvas.isSelectingBackground }]),
                                    onClick: _cache[61] || (_cache[61] = ($event: any) => {$setup.setCanvasSelectedShape({ id: '' }); $setup.canvas.isSelectingBackground = true})
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_badge, {
                                        class: "top-left-badge normal-text",
                                        color: "danger",
                                        onClick: _cache[60] || (_cache[60] = ($event: any) => ($setup.clearCanvasBackground()))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_icon, { icon: $setup.close }, null, 8, ["icon"])
                                        ]),
                                        _: 1
                                      }),
                                      _createElementVNode("img", {
                                        src: $setup.canvas.backgroundImage.src
                                      }, null, 8, _hoisted_10)
                                    ]),
                                    _: 1
                                  }, 8, ["class"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.canvas.panelShapes, (shape, i) => {
                            return (_openBlock(), _createBlock(_component_ion_col, {
                              "size-xs": "3",
                              "size-lg": "2",
                              class: "ion-no-padding ion-text-center",
                              key: shape.id,
                              onClick: ($event: any) => ($setup.setCanvasSelectedShape(shape, true, true))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_card, {
                                  class: _normalizeClass(["material-card", { 'hidden-shape': !shape.visible, 'highlight-card': $setup.canvas.selectedShape.id == shape.id }])
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_badge, {
                                      class: "top-left-badge normal-text",
                                      color: "medium"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(i+1), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createElementVNode("img", {
                                      src: $setup.getShapeDataURL($setup.stageRef, shape)
                                    }, null, 8, _hoisted_11),
                                    _createVNode(_component_ion_text, { class: "material-text normal-text ion-text-nowrap" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(shape.text || shape.name), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["class"])
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, $setup.canvas.selectedSectionTab == '已選']
                      ]),
                      _withDirectives(_createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _withDirectives(_createVNode(_component_ion_col, {
                            "size-xs": "4",
                            "size-md": "3",
                            class: "ion-no-padding ion-text-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card, {
                                class: "material-card card-valign",
                                onClick: _cache[62] || (_cache[62] = ($event: any) => ($setup.clearCanvasBackground())),
                                button: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_text, { class: "material-text" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($setup.t('transparentBackground')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, $setup.canvas.selectedSectionTab == 'background']
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.materials, (material) => {
                            return _withDirectives((_openBlock(), _createBlock(_component_ion_col, {
                              "size-xs": "4",
                              "size-md": "3",
                              class: "ion-no-padding ion-text-center",
                              key: material.id
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_card, {
                                  class: _normalizeClass([{ 'highlight-card': $setup.canvas.selectedPanelShape.id == material.id }, "material-card card-valign"]),
                                  onClick: ($event: any) => ($setup.addMaterialToCanvas(material, null, $event)),
                                  button: ""
                                }, {
                                  default: _withCtx(() => [
                                    ((new Date().valueOf() - new Date(material.createdAt).valueOf()) / (1000*60*60*24) < 30)
                                      ? (_openBlock(), _createBlock(_component_ion_badge, {
                                          key: 0,
                                          style: {"letter-spacing":"normal"},
                                          class: "top-right-badge",
                                          color: "danger"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString($setup.t('new')), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (material.photo)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 1,
                                          src: $setup.addResizeUrlParams(material.photoLink, 200, false)
                                        }, null, 8, _hoisted_12))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                          _createElementVNode("span", _hoisted_14, _toDisplayString(material.text), 1),
                                          _hoisted_15
                                        ])),
                                    _createVNode(_component_ion_text, { class: "material-text" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(material.name), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["class", "onClick"])
                              ]),
                              _: 2
                            }, 1024)), [
                              [_vShow, material.category == $setup.canvas.selectedSectionTab]
                            ])
                          }), 128))
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, $setup.canvas.selectedSectionTab != '已選']
                      ])
                    ], 544), [
                      [_vShow, !$setup.canvas.isFiltering]
                    ]),
                    _withDirectives(_createElementVNode("div", {
                      class: "material-div grey-bg",
                      onTouchmove: _cache[64] || (_cache[64] = (e) => e.stopPropagation())
                    }, [
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values($setup.photoFilters), (filter) => {
                            return (_openBlock(), _createBlock(_component_ion_col, {
                              "size-xs": "4",
                              "size-md": "3",
                              class: "ion-no-padding ion-text-center",
                              key: filter
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_card, {
                                  class: _normalizeClass(["material-card card-valign", { 'highlight-card': $setup.canvas.selectedFilter == filter }]),
                                  onClick: ($event: any) => ($setup.applyFilter(filter)),
                                  button: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_text, { class: "material-text" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString($setup.t(filter)), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["class", "onClick"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ], 544), [
                      [_vShow, $setup.canvas.isFiltering]
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}